import { useCallback, useRef } from "react";

// Get steady reference to a function without triggering re-renders on dependency changes
export function useEvent<T extends (...args: never[]) => unknown>(fn: T) {
  const ref = useRef(fn);
  ref.current = fn;
  return useCallback((...args: Parameters<T>) => ref.current(...args), []) as T;
}
